import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const projectsSlice = createSlice({
    name: "selectedProjects",
    initialState,
    reducers: {
        projectUnSelected: (state, action) => {
            state.push(action.payload);
        },
        projectSelected: (state, action) => {
            const indexToDelete = state.findIndex(p => p === action.payload);
            if (indexToDelete !== -1) {
                state.splice(indexToDelete, 1);
            }
        }
    }
});

export default projectsSlice.reducer;
export const { projectUnSelected, projectSelected } = projectsSlice.actions;